import { ActionType } from '../types.ds';
import { EndGameActions } from '../types.ds';
import { Socket } from 'socket.io-client';
import { SocketEmit } from '../types.ds';
import { SocketOn } from '../types.ds';

import { io } from 'socket.io-client';

const socketWithoutTypes: Socket = io(
  process.env.REACT_APP_SOCKET_END_POINT || 'http://localhost:5000',
  {
    transports: ['websocket', 'polling'],
  }
);

interface SocketEventsOn {
  [SocketOn.TableCreated]: (
    allTables: string,
    table: string,
    player: string,
    chat: string
  ) => void;
  [SocketOn.TableDeleted]: (data: string) => void;
  [SocketOn.TableJoined]: (table: string) => void;
  [SocketOn.TableUpdated]: (table: string) => void;
  [SocketOn.SendTables]: (allTables: string) => void;
  [SocketOn.DisconnectPlayer]: (table: string) => void;
  [SocketOn.BetUpdate]: (players: string) => void;
  [SocketOn.Dealt]: (table: string) => void;
  [SocketOn.ActionMade]: (
    table: string,
    actionType: ActionType | undefined
  ) => void;
  [SocketOn.DealerMadeAction]: (
    table: string,
    actionType: ActionType | undefined
  ) => void;
  [SocketOn.WinnersCounted]: (table: string) => void;
  [SocketOn.GameEnded]: (table: string) => void;
  [SocketOn.Error]: (message: string) => void;
  [SocketOn.Message]: (message: string, type?: 'chat') => void;
  [SocketOn.BalanceToppedUp]: (player: string) => void;
  [SocketOn.BalanceWithdrawl]: (player: string) => void;
  [SocketOn.ChatServerMessage]: (message: string) => void;
  [SocketOn.GlobalChatServerMessage]: (message: string) => void;
}

type SocketEventNamesOn = keyof SocketEventsOn;

interface SocketEventsEmit {
  [SocketEmit.JoinTable]: (
    table: string,
    playerId: string,
    name: string,
    address: string,
    balance: number,
    id?: string | undefined,
    avatar?: string | undefined
  ) => void;
  [SocketEmit.CreateTable]: (tableName: string, playerId: string, name: string, address: string, balance: number, banner: File | null, bannerName: string | undefined, playerAvatar: string | undefined, isPublic: boolean, role: number) => void;
  [SocketEmit.LeaveTable]: (
    playerId: string | undefined,
    tableId: string | undefined
  ) => void;
  [SocketEmit.UpdateTable]: (
    tableId: string | undefined,
    newName: string | undefined
  ) => void;
  [SocketEmit.RemoveTable]: (
    tableId: string | undefined
  ) => void;
  [SocketEmit.GetTables]: () => void;
  [SocketEmit.Action]: (
    actionType: ActionType,
    tableId: string | undefined,
    playerId: string | undefined
  ) => void;
  [SocketEmit.Deal]: (tableId: string | undefined) => void;
  [SocketEmit.EndGame]: (
    tableId: string | undefined,
    playerId: string | undefined,
    endGameActionType: EndGameActions
  ) => void;
  [SocketEmit.RemoveBet]: (
    tableId: string | undefined,
    playerId: string | undefined,
    betIndex: number
  ) => void;
  [SocketEmit.SetBet]: (
    tableId: string | undefined,
    spotId: string,
    playerId: string | undefined,
    bet: number
  ) => void;
  [SocketEmit.TopupBalance]: (
    balance: number,
    tableId: string,
    playerId: string
  ) => void;
  [SocketEmit.BalanceWithdrawl]: (
    balance: number,
    tableId: string,
    playerId: string
  ) => void;
  [SocketEmit.ChatSendMessage]: (table: string, message: string) => void;
  [SocketEmit.GlobalChatSendMessage]: (message: string) => void;
}

type SocketEventNamesEmit = keyof SocketEventsEmit;

interface SocketWithTypedEvents<T extends keyof SocketEventsEmit> {
  on<E extends SocketEventNamesOn>(
    event: E,
    listener: SocketEventsOn[E]
  ): Socket;
  emit<E extends T>(event: E, ...args: Parameters<SocketEventsEmit[E]>): Socket;
  off: Socket['off'];
}

export const socket: SocketWithTypedEvents<SocketEventNamesEmit> =
  socketWithoutTypes;
